/** @format */

import { CountUp } from 'countup.js';

/**
 * Animate Odometer.
 */
export const animateOdometer = (): void => {
  const odometerNumbers: NodeListOf<HTMLElement> =
    document.querySelectorAll('.odometer-number');
  if (odometerNumbers.length > 0) {
    odometerNumbers.forEach((odometer) => {
      if (odometer.dataset.counterNumber) {
        const counterNumber = parseInt(odometer.dataset.counterNumber, 10);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const countUp = new CountUp(odometer, counterNumber, {
          enableScrollSpy: true,
          scrollSpyOnce: true,
          duration: 2,
        });
      }
    });
  }
};
